import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const FileUploadStyled = styled.div`
  margin-bottom: 8rem;
  border-top: 0.1rem solid ${colors.neutral[300]};
  margin-top: 4rem;
  padding-top: 4rem;
`;
